import { IProduct } from '../interfaces/catalog'
import { PackageType } from '../interfaces/enums'
import { HideCounterFields } from '../ui/components/MainFooter/MainFooter.types'
/**
 * It validates if term is a valid search term
 * @param value: string
 * @param minLength: number
 * @returns true | false
 */
export const isSearchable = (value: string, minLength: number = 0): boolean =>
  value.trim().length >= minLength

/**
 * Returns a simple validation that checks if a value is a string
 * @param value: unknown
 * @returns true | false
 */
export const isString = (value: unknown): value is string =>
  typeof value === 'string'

/**
 * Returns a simple validation that checks if a value is a number
 * @param value: unknown
 * @returns true | false
 */
export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value)

/**
 * Returns a simple validation that checks if a value is an object
 * @param value: unknown
 * @returns true | false
 */
export const isObject = (value: unknown): value is object =>
  typeof value === 'object' && !Array.isArray(value) && value !== null

/**
 * Returns a simple validation that checks if a value is an array
 * @param value: unknown
 * @returns true | false
 */
export const isArray = (value: unknown): value is unknown[] =>
  typeof value === 'object' && Array.isArray(value) && value !== null

/**
 * Returns a simple validation that checks if a value is an array
 * @param value: unknown
 * @returns true | false
 */
export const isNullish = (value: unknown): value is null =>
  value === null || value === undefined

/**
 * Returns the quantity for a product considering the package type
 */
export const getQtyPerPackageType = (
  quantity: number,
  packageType?: string | null
): number => (packageType === PackageType.HALFBOX ? quantity / 2 : quantity)

export const productNotNullFields = (
  fieldsList: HideCounterFields[],
  product?: IProduct
): boolean =>
  fieldsList.filter(
    (field) =>
      product &&
      product[field] &&
      product[field] !== null &&
      product[field].length > 0
  ).length > 0
